import React, {Component} from 'react';
import {ModalBody} from 'reactstrap';
import { ShopifyLinkComponent } from '../link_acocunts/ShopifyLink';
import { TiendaNubeLinkComponent } from '../link_acocunts/TiendaNubeLink';
import {
    SHOPIFY_CHANNEL,
    TIENDA_NUBE_CHANNEL,
    VTEX_CHANNEL,
    CHANNEL_TYPE_PAID_MEDIA,
    CHANNEL_INFO_BY_CHANNEL,
    ANALYTICS_CHANNEL
} from "../../channels/channels";
import { withTranslation } from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { PaidMediaReconnectFlow } from './PaidMediaReconnectFlow';
import {UserModulesContext} from '../../../context/UserModulesContext';
import {ShopifyLinkRequest} from '../../channels/shopify/ShopifyLinkRequest';

class ReconnectAdAccountFormClass extends Component {
    // Shopify por link de instalación (tanda 23/10): con el flag, una tienda de Shopify se vuelve a autorizar
    // pidiendo un link nuevo. El OAuth de la app pública no sirve para las tiendas instaladas con una app
    // personalizada (estaba roto para las tres). Sin el flag, el OAuth de siempre.
    static contextType = UserModulesContext;

    render() {
        const { t } = this.props;
        const adAccountData = this.props.adAccountData;

        if (!adAccountData) {
            return null;
        }

        if (adAccountData.channel === SHOPIFY_CHANNEL && this.context && this.context.shopifyInstallByLink === true) {
            // `agency_client_id` sólo viene cuando la tienda se abre desde la ficha de su cliente. `onToggle` cierra
            // el modal: nunca `onReconnected`, que en el clásico recarga la página y todavía no se reconectó nada.
            return <ShopifyLinkRequest reconnectShop={adAccountData.store_subdomain || null}
                                       agencyClientId={adAccountData.agency_client_id || null}
                                       onClose={this.props.onToggle}/>;
        }

        const channelInfo = CHANNEL_INFO_BY_CHANNEL[adAccountData.channel];
        const isPaidMedia = channelInfo && channelInfo.channelType === CHANNEL_TYPE_PAID_MEDIA;
        const isAnalytics = adAccountData.channel === ANALYTICS_CHANNEL;
        if (isPaidMedia || isAnalytics) {
            return <PaidMediaReconnectFlow
                adAccountData={adAccountData}
                onReconnected={this.props.onReconnected}
                onToggle={this.props.onToggle}
            />;
        }

        const commonProps = {
            hasConnection: false,
        };

        let linkComponent = null;
        switch(adAccountData.channel) {
            case SHOPIFY_CHANNEL:
                linkComponent = <ShopifyLinkComponent {...commonProps} subdomain={adAccountData.store_subdomain} disabled={!adAccountData.store_subdomain} />;
                break;
            case TIENDA_NUBE_CHANNEL:
                linkComponent = <TiendaNubeLinkComponent {...commonProps} disabled={false} />;
                break;
            case VTEX_CHANNEL:
                linkComponent = <p>{t('reconnect_modal.vtex_reconnect_instructions')}</p>;
                break;
            default:
                linkComponent = <p>La reconexión para el canal {adAccountData.channel} no está implementada.</p>;
        }

        return (
            <ModalBody>
                <div className="modal-section">
                    <p>Para reconectar la cuenta es necesario que vuelva a autenticarse en la plataforma.</p>
                    {adAccountData.channel === TIENDA_NUBE_CHANNEL && (
                        <div className="alert alert-info" style={{ fontSize: '0.9em' }}>
                            <FontAwesomeIcon icon="info-circle" style={{ marginRight: '0.5em' }} />
                            {t('add_store_modal.tienda_nube_session_tip')}
                        </div>
                    )}
                    {linkComponent}
                </div>
            </ModalBody>
        )
    }
}

export const ReconnectAdAccountForm = withTranslation()(ReconnectAdAccountFormClass); 